import { Context } from "@silvertours/front-legacy-shared";
var useClientContext = Context.useClientContext;
var hasContext = Context.guardContext;
var join = function(baseUrl, path) {
    var delimiter = path.indexOf("/") === 0 ? "" : "/";
    return "".concat(baseUrl).concat(delimiter).concat(path);
};
var useNewsletter = function() {
    var result = useClientContext("newsletter");
    hasContext("newsletter", result);
    var baseUrl = result.value.baseUrl;
    return {
        formatApiUrl: function formatApiUrl(path) {
            return join(baseUrl, path);
        }
    };
};
export { useNewsletter };
